
<div class=" align-items-center row  h-100 to-left-1 {{(['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'].includes(params.data.status)?'cursor-pointer':'')}}
{{(['PAUSED', 'DELETED'].includes(params.data.status)) ? 'faded' : ''}}"
(click)="$event.stopPropagation(); params.data.status !== 'DELETED' && routeToDetails()" >

    <ng-container *ngIf="!(params.data.lastSyncTime === undefined)">
        <div
            matTooltip="{{((params.data.lastSyncStatus === 'warning' || params.data.lastSyncStatus === 'error') && params.data.errorTables === false)? 'Click to get info':''}}"
            (click)="$event.stopPropagation(); params.data.status !== 'DELETED' && getTables(params.data)"
            [ngClass]="params.data.errorTables ? 'active' : ''">
            <div class="alert-body ">

                <div class="alert-message text-secondary">
{{params.data.lastSyncTime}}
                <span *ngIf="params.data.lastSyncTime !== '-/-'">ago</span>
                </div>
                <div *ngIf="params.data.lastSyncTime !== '-/-' " class="pipe-line"></div>
                <!-- <div class="alert-icon mt-0">
                    <i class="fa fa-exclamation-circle" *ngIf="params.data.lastSyncStatus === 'warning'"></i>
                    <i class="fa fa-times-circle" *ngIf="params.data.lastSyncStatus === 'error'"></i>
                    <i class="fa fa-check-circle" *ngIf="params.data.lastSyncStatus === 'success'"></i>
                </div>
                <div class="alert-message cap">
                    {{params.data.lastSyncStatus}}
                </div> -->
                @if(params.data.lastSyncStatus !== '-/-' && params.data.lastSyncStatus !== '') {
                <div class="status-chip " [ngClass]="{
                                    'success': params.data.lastSyncStatus === 'success',
                                    'warning': params.data.lastSyncStatus === 'warning',
                                    'error': params.data.lastSyncStatus === 'error',
                                    'action-required': params.data.lastSyncStatus === 'action required'
                                }">
                
                    <img *ngIf="params.data.lastSyncStatus === 'success'" src="../../assets/images/svg/success-updated.svg">
                    <img *ngIf="params.data.lastSyncStatus === 'action required'" src="../../assets/images/svg/warning-updated.svg" matTooltip="Some tables have run into errors. Please take action on Integration details page.">
                    <i *ngIf="params.data.lastSyncStatus === 'warning'" class="fa fa-exclamation-circle"
                        matTooltip="Please rerun the tables"></i>
                    <i *ngIf="params.data.lastSyncStatus === 'error'" class="fa fa-times-circle"></i>
                    <span class="alert-message cap text-capitalize">{{ params.data.lastSyncStatus }}</span>
                </div>
                }

            </div>
        </div>
        <!-- <div  class="grid-cell text-truncate px-0 m-l12 m-t-22">
        </div> -->
   </ng-container>
   <span class="loading-dots" *ngIf="(params.data.lastSyncTime === undefined)">Loading</span>
</div>



